"use strict";
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.removeBody = exports.handleBodyOverlap = exports.getAllBodies = exports.extractNearbyCollisionData = exports.checkCollision = exports.getPotentialMatches = exports.createPolygonFromPoints = exports.createBox = exports.createPolygon = exports.getPolygonArray = exports.createPoint = exports.createCircle = exports.createCollisionSystem = void 0;
const detect_collisions_1 = require("detect-collisions");
const utils_1 = require("../server/utils");
const constants_1 = __importDefault(require("./constants"));
const Collisions = require('detect-collisions');
function createCollisionSystem() {
    return new detect_collisions_1.System();
}
exports.createCollisionSystem = createCollisionSystem;
function createCircle(system, x, y, radius, settings) {
    if (!settings) {
        settings = {};
    }
    return system.createCircle({ x: x, y: y }, radius, settings);
}
exports.createCircle = createCircle;
function createPoint(system, x, y, settings) {
    if (!settings) {
        settings = {};
    }
    return system.createPoint({ x: x, y: y }, settings);
}
exports.createPoint = createPoint;
function getPolygonArray(width, height) {
    console.log('polygon array', [[0, -height],
        [width, -height],
        [width, 0],
        [0, 0]]);
    return [
        [0, -height],
        [width, -height],
        [width, 0],
        [0, 0]
    ];
}
exports.getPolygonArray = getPolygonArray;
function createPolygon(system, x, y, array, settings) {
    if (!settings) {
        settings = {};
    }
    settings.angle = settings.rotation;
    const convertedArray = array.map(coordinate => {
        return { x: coordinate[0], y: coordinate[1] };
    });
    return system.createPolygon({ x: x, y: y }, convertedArray, settings);
}
exports.createPolygon = createPolygon;
function createBox(system, x, y, width, height, settings) {
    if (!settings) {
        settings = {};
    }
    // settings.angle = settings.rotation
    // console.log('array', array)
    // console.log(' converted array', convertedArray)
    return system.createBox({ x: x, y: y }, width, height, settings);
}
exports.createBox = createBox;
function createPolygonFromPoints(system, x, y, points, settings) {
    if (!settings) {
        settings = {};
    }
    settings.angle = settings.rotation;
    // console.log('array', array)
    // console.log(' converted array', convertedArray)
    return system.createPolygon({ x: x, y: y }, points, settings);
}
exports.createPolygonFromPoints = createPolygonFromPoints;
function getPotentialMatches(system, body) {
    return system.getPotentials(body);
}
exports.getPotentialMatches = getPotentialMatches;
function checkCollision(system, body, collider) {
    return system.checkCollision(body, collider);
}
exports.checkCollision = checkCollision;
function extractNearbyCollisionData(system, coords) {
    let filteredData = {
        circles: [],
        polygons: []
    };
    const interestRadius = constants_1.default.PLAYER_INTEREST_MANAGEMENT;
    const extendedInterestRadius = interestRadius * 2;
    const bodies = system.all();
    for (let i = 0; i < bodies.length; i++) {
        const body = bodies[i];
        const { x, y } = body.pos;
        const distance = (0, utils_1.distanceBetween)(coords.x, coords.y, x, y);
        if (body.type === 'Circle' && distance <= interestRadius) {
            filteredData.circles.push({ x, y, r: body.r });
        }
        else if (body.type !== 'Circle' && distance <= extendedInterestRadius) {
            filteredData.polygons.push({
                x,
                y,
                angle: body.angle,
                points: body.points,
                centroid: body.getCentroidWithoutRotation()
            });
        }
    }
    return filteredData;
}
exports.extractNearbyCollisionData = extractNearbyCollisionData;
function getAllBodies(system) {
    return system.all();
}
exports.getAllBodies = getAllBodies;
function handleBodyOverlap(body, result, system) {
    // console.log("handle body overlap", body, result, system)
    body.x -= result.overlapV.x;
    body.y -= result.overlapV.y;
    system.insert(body);
    return { x: body.x, y: body.y };
}
exports.handleBodyOverlap = handleBodyOverlap;
function removeBody(system, body) {
    return system.remove(body);
}
exports.removeBody = removeBody;
